import { useEffect } from "react";
import { useRecoilState, useResetRecoilState } from "recoil";
import { myTimesheetBooleanState } from "my-timesheet/states";

export const useMyTimesheetBooleanState = ({
  id,
  initialState = false,
}: {
  id: string;
  initialState?: boolean;
}) => {
  const [state, setState] = useRecoilState(myTimesheetBooleanState(id));
  const resetState = useResetRecoilState(myTimesheetBooleanState(id));

  useEffect(() => {
    if (initialState !== state) {
      setState(initialState);
    }
  }, [initialState]); // eslint-disable-line react-hooks/exhaustive-deps

  return { state, setState, resetState };
};

export default useMyTimesheetBooleanState;
